/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react'
import { Paper, makeStyles, Grid, Box, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'
import ExtraElement from '../ExtraElements/ExtraElement'
import { fetchResearches } from '../../../../api'
import moment from 'moment'

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.termsColor ? theme.termsColor : 'rgba(0, 0, 0, 0.45)',
        textAlign: 'center',
        letterSpacing: 0.5,
        textTransform: 'uppercase',
        fontSize: '0.7rem',
        margin: 'auto'
    },
    paper: {
        background: 'rgba(255,255,255,0.95)',
        boxShadow: theme.boxShadow ? theme.boxShadow : '0 3px 5px rgba(0,0,0,0.1)',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        [theme.breakpoints.down(600)]: {
            borderRadius: 0 + 'px!important'
        }
    },
    title: {
        fontWeight: 600,
        fontSize: '1.1rem',
        lineHeight: '1.4rem'
    },
    tableWrapper: {
        width: '100%',
        overflowX: 'auto'
    },
    table: {
        '& td': {
            whiteSpace: 'nowrap',
            paddingBottom: 14
        },
        '& tbody tr:last-child td, & tbody tr:last-child th': {
            border: 0
        }
    },
    titleCell: {
        whiteSpace: 'normal!important',
        fontWeight: 500
    },
    priceLabel: {
        maxWidth: 250,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: 500
    }
}))

function Research({ showSlogansLast = false }) {
    const [researches, setResearches] = useState([])

    const classes = useStyles()

    useEffect(() => {
        fetchResearches().then(response => {
            console.log('response.data', response.data)
            if (response.data) {
                setResearches(response.data)
            }
        })
    }, [])

    const renderSlogans = (
        <Paper className={classes.paper + ' extra-element-paper'} elevation={1}>
            <Box px={{ xs: 2, sm: 3 }} pb={0.5} pt={2}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <ExtraElement
                            imageSrc={'/img/2023-ssl.png'}
                            title={'Osallistuminen on turvallista ja vie vain hetken.'}
                            description={'Business Finland tukee tuote&shy;kehitystämme. Tutkimuksemme ovat tehokkaita ja turvallisia.'}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <ExtraElement
                            imageSrc={'/img/2023-asml.png'}
                            title={'Suomen Asiakkuus­markkinointi­liiton jäsen.'}
                            description={'Olemme ASML:n jäsen ja hyödynnämme tietosuoja- ja kuluttaja-asioissa heidän ohjeistuksiaan.'}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <ExtraElement
                            imageSrc={'/img/2023-avainlippu.png'}
                            title={'Olemme tunnettu täysin suomalaisena ja luotettavana toimijana.'}
                            description={'Vastauksiasi ei jaeta ulkopuolisille ilman, että olet antanut siihen luvan. Lisätietoja käyttöehdoissa.'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box px={{ xs: 2, sm: 3 }} pb={{ xs: 3, sm: 2.5 }} pt={{ xs: 4, sm: 2.5 }}>
                <Box fontWeight={400}>
                    Tutustu toimintaamme ja lue meistä lisää{' '}
                    <a href="https://www.leadspark.fi" target="_blank">
                        yrityksemme verkkosivuilla
                    </a>
                    .
                </Box>
            </Box>
        </Paper>
    )

    const renderResearches = researches?.length > 0 && (
        <Paper className={classes.paper + ' extra-element-paper'} elevation={1}>
            <Box px={{ xs: 2, sm: 3 }} pt={3} pb={0}>
                <Box className={classes.title + ' extra-element-title'} mb={0.75}>
                    Aikaisemmat tutkimukset
                </Box>
                <Box fontWeight={400}>
                    Tutkimuksen palkinnon arvonta suoritetaan heti tutkimuksen päätyttyä. Listassa viimeisimmät 20 Tutkimuskeskuksen tekemää
                    tutkimusta.
                </Box>
            </Box>
            <Box px={{ xs: 0.5, sm: 1.5 }} pb={1} className={classes.tableWrapper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Nimi</TableCell>
                            <TableCell>Aika ja kohde</TableCell>
                            <TableCell>Palkinto ja onnekkain</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {researches.map(research => (
                            <TableRow key={research.id}>
                                <TableCell className={classes.titleCell}>{research.title}</TableCell>
                                <TableCell>
                                    <b>
                                        {moment(research.starts_at).format('DD.MM.')} - {moment(research.ends_at).format('DD.MM.YYYY')}
                                    </b>
                                    <br />
                                    {research.client_name}
                                </TableCell>
                                <TableCell>
                                    <div className={classes.priceLabel}>{research.price}</div>
                                    {research.winner_name} ({research.winner_from})
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        </Paper>
    )

    return <>{showSlogansLast ? [renderResearches, renderSlogans] : [renderSlogans, renderResearches]}</>
}

export default Research
